/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { pendingSyncStateDtoSchema } from "../pendingSyncStateDtoSchema";
import { z } from "zod/v4";

export const getPendingSyncState200Schema = z.array(z.lazy(() => pendingSyncStateDtoSchema))

export const getPendingSyncStateQueryResponseSchema = z.lazy(() => getPendingSyncState200Schema)